import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { TrackedObject } from 'tracked-built-ins';

import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export default class AssetTokenConfigtModel extends Model.extend(Validations) {
  @attr('string') headline;
  @attr('json', {
    defaultValue() {
      return new TrackedObject({});
    },
  })
  callbacks;
  @attr('array') origins;

  // Meta fields
  @attr cmsCreated;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('asset', { async: true, inverse: 'assetTokenConfigs' }) assets;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return this.headline;
  }
}
